<!--
 * @FileDescription: 账期自动付款设置对话框
 * @Author: 陈文景
 * @Date: 2022-12-27 13:48:03
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="账期自动付款设置" :visible.sync="visible" width="880px" :before-close="close">
    <div class="top">
      <el-select v-model="parameter.userGroup" multiple collapse-tags filterable clearable size="medium" placeholder="请选择用户类型" @change="getCreditsUserList">
        <el-option v-for="item in userTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <BatchSearch @clear="handleClearBatchSearch" @search="handleSearchBatchSearch" />
    </div>

    <div v-if="multipleSelection.length" class="batch-number">
      <span>批量设置拆单数量：</span>
      <el-input-number v-model="parameter.billBatchQty" size="mini" controls-position="right" :min="1" :max="9999" />
      <el-button size="mini" @click="cancelUpdateBillsQty">取消</el-button>
      <el-button type="primary" size="mini" @click="batchUpdateBillsQty">确定</el-button>
    </div>

    <el-table v-loading="loading" ref="table" :data="credits" size="medium" border row-key="id" :style="{ width: `${tableWidth}%` }" :height="`${tableHeight}px`" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" width="50" />
      <el-table-column prop="email" label="邮箱/手机号" >
        <template slot-scope="{row}">
          <div>{{ row.email }}</div>
          <div>{{ row.phone }}</div>
        </template>
      </el-table-column>
      
      <el-table-column prop="billBatchQty" align="center" label="拆单数量" width="160px">
        <template v-slot="{ row }">
          <el-input-number v-model="row.billBatchQty" size="small" controls-position="right" :min="1" :max="9999" @change="() => onUpdateSingleBillsQty(row)" />
        </template>
      </el-table-column>
    </el-table>

    <div class="footer">
      <el-pagination background :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="parameter.pageNumber" @size-change="sizeChange" @current-change="currentChange" />
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'
import BatchSearch from './BatchSearch.vue'

let parameter = {
  userGroup: [], // 用户类型
  billType: [], // 生成类型
  billCycle: [], // 账单周期
  ids: [], // 批量设置拆单的用户数据ID
  searchContent: undefined, // 搜索内容
  billBatchQty: undefined, // 批量生成的数量
  pageSize: 20,
  pageNumber: 1
}

export default {
  components: {
    BatchSearch
  },
  data() {
    return {
      visible: false,

      formatTimeStamp,

      tableWidth: 100,
      tableHeight: 380,

      parameter: { ...parameter },

      // 用户类型下拉选项
      userTypeOptions: [
        { label: '独立站', value: 100 },
        { label: '默认', value: -1 }
      ],

      loading: false,
      credits: [],
      total: 0,

      multipleSelection: []
    }
  },
  computed: {
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 获取信用用户列表
     */
    async getCreditsUserList() {
      try {
        this.loading = true
        let { data } = await API.getCreditsUserList(this.parameter)
        this.total = data.total
        this.credits = data.list
        this.parameter.billBatchQty = undefined
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * API 批量更新生成账单订单数量
     */
    async batchUpdateBillsQty() {
      if (this.parameter.billBatchQty) {
        if (this.multipleSelection.length) {
          this.parameter.ids = this.multipleSelection.map((item) => item.id)
        }
        let { code, message } = await API.batchUpdateBillsQty(this.parameter)
        if (code === 10000) {
          this.$message.success(message)
          this.getCreditsUserList(false)
        } else {
          this.$message.error(message)
        }
      }
    },

    /**
     * API 更新单个账单订单数量
     */
    async updateSingleBillsQty(id, billBatchQty) {
      let { code, message } = await API.updateSingleBillsQty({ id, billBatchQty })
      if (code === 10000) {
        this.$message.success(message)
        this.getCreditsUserList(false)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 批量搜索清除内容的回调事件
     */
    handleClearBatchSearch() {
      this.parameter.searchContent = undefined
      this.getCreditsUserList()
    },

    /**
     * 批量搜索的回调事件
     *
     * @param {String} value 搜索关键字
     */
    handleSearchBatchSearch(value) {
      if (value) {
        this.parameter.searchContent = value.trim()
        this.getCreditsUserList()
      }
    },

    /**
     * 当选择项发生变化时会触发该事件
     *
     * @param {Array} selection
     */
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },

    /**
     * 取消批量设置拆单数量
     */
    cancelUpdateBillsQty() {
      this.parameter.ids = []
      this.$refs.table.clearSelection()
      this.parameter.billBatchQty = undefined
    },

    /**
     * 某行输入框的回到事件
     *
     * @param {Object} row 当前操作的行数据
     */
    onUpdateSingleBillsQty(row) {
      if (row.billBatchQty) {
        this.updateSingleBillsQty(row.id, row.billBatchQty)
      }
    },

    /**
     * 显示对话框
     */
    show() {
      this.visible = true
      this.getCreditsUserList()
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据的方法
     */
    clear() {
      this.loading = false
      this.credits = []
      this.total = 0
      this.multipleSelection = []
      this.parameter = { ...parameter }
    },

    /**
     * 每页显示条数发生改变时的回调
     *
     * @param {Number} size 每页显示条数
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getCreditsUserList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param {Number} current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getCreditsUserList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  margin-bottom: 25px;
  .el-select {
    margin-right: 15px;
  }
}

.batch-number {
  margin-bottom: 8px;
  .el-button {
    margin-left: 8px;
  }
}

.footer {
  text-align: end;
  margin-top: 15px;
}
</style>
